import * as types from "../../actions/actionTypes";
const initialState = {
  loading: true,
  removeLoading: false,
  inProcess: false,
  data: { data: [], links: {}, message: [], meta: {} },
  selected: {},
  error: "",
  removeSuccess: false,
  imagesLoading: true,
  imagesError: false,
  images: []
};

const PettyCashierReceive = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_REMOVE_RECEIVE_REQUEST:
      return { ...state, removeLoading: true, loading: true };
    case types.PETTY_CASHIER_REMOVE_RECEIVE_SUCCESS:
      return {
        ...state,
        ...action.payLoad,
        removeLoading: false,
        loading: false
      };
    case types.PETTY_CASHIER_REMOVE_RECEIVE_FAILURE:
      return {
        ...state,
        ...action.payLoad,
        removeLoading: false,
        loading: false
      };

    case types.PETTY_CASHIER_GET_IMAGE_RECEIVE_REQUEST:
      return { ...state, imagesLoading: true, imagesError: false };
    case types.PETTY_CASHIER_GET_IMAGE_RECEIVE_SUCCESS:
      return { ...state, images: action.payLoad, imagesLoading: false };
    case types.PETTY_CASHIER_GET_IMAGE_RECEIVE_FAILURE:
      return { ...state, imagesLoading: false, imagesError: true };

    case types.PETTY_CASHIER_STORE_RECEIVE_REQUEST:
      return { ...state, inProcess: true };
    case types.PETTY_CASHIER_STORE_RECEIVE_SUCCESS:
      return { ...state, inProcess: false };
    case types.PETTY_CASHIER_STORE_RECEIVE_FAILURE:
      return { ...state, inProcess: false };

    case types.PETTY_CASHIER_UPDATE_RECEIVE_REQUEST:
      return { ...state, inProcess: true };
    case types.PETTY_CASHIER_UPDATE_RECEIVE_SUCCESS:
      return { ...state, inProcess: false };
    case types.PETTY_CASHIER_UPDATE_RECEIVE_FAILURE:
      return { ...state, inProcess: false };

    case types.PETTY_CASHIER_GET_RECEIVE_REQUEST:
      return { ...state, loading: true, error: "", selected: {} };
    case types.PETTY_CASHIER_GET_RECEIVE_SUCCESS:
      return { ...state, selected: action.payLoad, loading: false };
    case types.PETTY_CASHIER_GET_RECEIVE_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default PettyCashierReceive;
